export const ErrorKeys = [
  'NotAuthorizedException',
  'TooManyFailedAttemptsException',
  'LimitExceededException',
  'CodeDeliveryFailureException',
  'ExpiredCodeException',
  'CodeMismatchException',
  'InvalidPasswordException',
  'UserAlreadyAuthenticatedException',
  'NetworkError',
  'AuthUserPoolException',
  'ResourceNotFoundException',
  'InternalErrorException',
  'UserLambdaValidationException',
  'VerifySoftwareTokenException',
  'AssociateSoftwareTokenException',
];
